<template>
  <v-row dense>
    <v-col cols="12" md="4">
      <v-select
        v-model="form.product_id"
        :items="productItems"
        item-title="label"
        item-value="value"
        :menu-props="selectMenuProps"
        :label="$t('ncrm.onboarding.templates.create.fields.product')"
        :loading="productLoading"
        :disabled="dialogMode === 'edit'"
      />
    </v-col>
    <v-col cols="12" md="4">
      <v-text-field
        v-model="form.name"
        :label="$t('ncrm.onboarding.templates.create.fields.name')"
      />
    </v-col>
    <v-col cols="12" md="4">
      <v-autocomplete
        v-model="form.default_owner_user_id"
        :items="ownerItems"
        item-title="label"
        item-value="value"
        :menu-props="selectMenuProps"
        :loading="ownerLoading"
        :label="$t('ncrm.onboarding.templates.create.fields.defaultOwnerUser')"
        clearable
        @update:search="$emit('owner-search', $event)"
        @update:model-value="$emit('default-owner-change', $event)"
      />
    </v-col>
    <v-col cols="12" md="4">
      <v-switch
        v-model="form.auto_move_next_stage_on_all_tasks_done"
        color="primary"
        inset
        :label="$t('ncrm.onboarding.templates.create.fields.autoMove')"
      />
    </v-col>
    <v-col cols="12" md="4">
      <v-switch
        v-model="form.allow_manual_stage_move_with_open_tasks"
        color="primary"
        inset
        :label="$t('ncrm.onboarding.templates.create.fields.allowManualMove')"
      />
    </v-col>
    <v-col cols="12" md="4">
      <v-switch
        v-model="form.is_active"
        color="primary"
        inset
        :label="$t('ncrm.onboarding.templates.create.fields.isActive')"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "NcrmOnboardingTemplateBasics",
  props: {
    form: { type: Object, required: true },
    productItems: { type: Array, default: () => [] },
    ownerItems: { type: Array, default: () => [] },
    selectMenuProps: { type: Object, default: () => ({}) },
    productLoading: { type: Boolean, default: false },
    ownerLoading: { type: Boolean, default: false },
    dialogMode: { type: String, default: "create" },
  },
  emits: ["owner-search", "default-owner-change"],
};
</script>
